import { render, staticRenderFns } from "./AvatarImage.vue?vue&type=template&id=4530381a&scoped=true&lang=pug"
import script from "./AvatarImage.vue?vue&type=script&lang=js"
export * from "./AvatarImage.vue?vue&type=script&lang=js"
import style0 from "./AvatarImage.vue?vue&type=style&index=0&id=4530381a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530381a",
  null
  
)

export default component.exports